import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {removeCatalogId} from '../common/catalog/catalog.actions';
import {take} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {selectRouteParam} from '../router.selectors';
import {
  selectNextRouteFragment,
  selectPreviousRouteFragment,
} from '../common/catalog/catalog.selectors';

@Injectable({
  providedIn: 'root',
})
export class AddOnUtilsService {
  constructor(
    private router: Router,
    private store: Store,
  ) {}

  handleFailedLoadAddon(failedCatalogId: string): void {
    const observables = {
      currentCatalogId: this.store.select(selectRouteParam('catalogId')),
      nextRouteFragment: this.store.select(selectNextRouteFragment),
      previousRouteFragment: this.store.select(selectPreviousRouteFragment),
    };
    combineLatest(observables)
      .pipe(take(1))
      .subscribe(obs => {
        const currentCatalogFailed = obs.currentCatalogId === failedCatalogId;
        this.store.dispatch(removeCatalogId({catalogId: failedCatalogId}));
        if (currentCatalogFailed) {
          const routeFragment =
            obs.nextRouteFragment || obs.previousRouteFragment || 'no-add-ons';
          const route = routeFragment.replace('../../', '');
          this.router.navigate([{outlets: {commerceElement: route}}]);
        }
      });
  }
}
